import ReactTable from "../../../util/ReactTable";
import AsyncBlock from "../../../components/forms/AsyncBlock";
import PageTitle from "../../../components/layout/PageTitle";
import PageSection from "../../../components/layout/PageSection";
import PageContainerFull from "../../../components/layout/PageContainerFull";
import {useEffect, useMemo, useState} from "react";
import useFetch2 from "../../../hooks/useFetch2";
import {Apis} from "../../../util/data";
import * as React from "react";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";
import {format} from "date-fns";

const DetallePedidoList = () => {

  const navigate = useNavigate()
  const {id} = useParams()
  const [dataTable,setDataTable] = useState([]);
  const {loading, data, error} = useFetch2(Apis.PROD + '/pedidos/' + id + '/detalle', []);
  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const columns = useMemo(
    () => [
      {
        header: 'Tipo',
        accessorKey: 'tipo',
      },
      {
        header: 'Codigo',
        accessorKey: 'codigo',
      },
      {
        header: 'Descripcion',
        accessorKey: 'descripcion',
      },
      {
        header: 'Cantidad',
        accessorKey: 'cantidad',
      },
      {
        header: 'Precio',
        accessorKey: 'precio'
      },
      {
        header: 'Total',
        accessorKey: 'total'
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [dataTable]
  )

  useEffect(() => {
    if(data){
      const newDataTable = []
      if(data.productosList?.length > 0){
        data.productosList.forEach(item => {
          const newItem = {}
          newItem.tipo = "Producto"
          newItem.codigo = item.codigo
          newItem.descripcion = item.nombre
          newItem.cantidad = item.cantidad
          newItem.precio = item.precio
          newItem.total = item.cantidad * item.precio
          newDataTable.push(newItem)
        })
      }
      if(data.citasList?.length > 0){
        data.citasList.forEach(item => {
          const newItem = {}
          newItem.tipo = "Cita"
          newItem.codigo = item.codigo
          newItem.descripcion = "Cita de " + item.consejeria + " con " + item.consejero + " el dia " + format(new Date(item.fecha), formatoFecha)
          newItem.cantidad = 1
          newItem.precio = item.precio
          newItem.total = item.precio
          newDataTable.push(newItem)
        })
      }
      setDataTable(newDataTable)
    }
  }, [data]);

  return (
    <PageContainerFull>

      <PageSection>
        <PageBackLabel text='Pedidos' onClick={() => navigate('/pedidos')}/>
        <PageTitle title={'Detalle del pedido'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={dataTable || []}
            customSearch
            noData='No existe detalle del pedido'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
    </PageContainerFull>
  )
}

export default DetallePedidoList
